import { Locale } from '@cumu/strings';

// keep ref in case user translates page.
const originalLang = document.documentElement.lang as Locale;

export function getLocale(): Locale {
  return originalLang;
}
